import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {TransactionService} from '../../../../../services/transaction.service';
import {ToastrService} from 'ngx-toastr';
import {Title} from '@angular/platform-browser';
import {Page} from '../../../../../model/page';
import {SelectOption} from '../../../model/SelectOption';

@Component({
    selector: 'app-m-transaction-view',
    templateUrl: './m-transaction-view.component.html',
    styleUrls: ['./m-transaction-view.component.scss'],
    providers: [
        TransactionService
    ]
})
export class MTransactionViewComponent implements OnInit, OnDestroy {

    public loading: boolean;
    public record: any;
    public filterOptions: {[key: string]: Array<SelectOption>};

    private id: string;
    private subscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private toast: ToastrService,
        private title: Title,
        private transactionService: TransactionService
    ) {
        this.title.setTitle('EDI - Transaction View');
    }

    ngOnInit() {
        this.loading = false;
        this.record = {};
        this.filterOptions = {
            ED1_STATUS: [
                {value: null, label: 'All'},
                {value: TransactionService.STATUS_NOT_SENT,   label: 'Not Sent'},
                {value: TransactionService.STATUS_PROCESSING, label: 'Processing'},
                {value: TransactionService.STATUS_SENT,       label: 'Sent'},
                {value: TransactionService.STATUS_FAILED,     label: 'Failed'},
                {value: TransactionService.STATUS_RESENDING,  label: 'Resending'}
            ],
            ED1_IN_OUT: [
                {value: null, label: 'All'},
                {value: '0',  label: 'Inbound'},
                {value: '1',  label: 'Outbound'}
            ]
        };

        this.id = (this.route.snapshot.params.id !== undefined && this.route.snapshot.params.id !== null)
            ? this.route.snapshot.params.id : 0;
        window.scroll(0, 0);
        this.getData();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onCancel() {
        this.loading = false;
        window.history.back();
    }

    private getData() {
        if (this.id.length > 0 && this.id.indexOf('_') > -1) {
            this.loading = true;
            const page = new Page();
            page.pageNumber = 0;
            page.size = 10;
            page.filterParams['UNIQUE_ID'] = this.id;
            this.subscription = this.transactionService.getTransactions(page, true).subscribe(result => {
                if (result.hasOwnProperty('data') && result.hasOwnProperty('count')) {
                    this.record = result.data[0];
                    this.record['ED1_TYPE'] = this.record['ED1_TYPE'].replace('/\0/g', '');
                    this.loading = false;
                } else {
                    this.toast.error('Unable to load data. Please try later!', 'Error');
                    setTimeout(() => {
                        this.onCancel();
                    }, 1000);
                }
            }, () => {
                this.onCancel();
                this.toast.error('Request timed out', 'Service Error');
            });
        } else {
            this.toast.error('Unable to fetch data.', 'Error');
            setTimeout(() => {
                this.onCancel();
            }, 1000);
        }
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/views/transactions/transaction-view/m-transaction-view.component.ts